import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, FormGroup} from "@mui/material";
import { useCallback } from "react";

const InfoDialog = ({title, text, open, onOk, action=null}) => {
  
  

  const renderAction = useCallback( () => {
      return <FormControlLabel 
                sx={{marginLeft: '0'}}
                label={action.label}
                control={<Checkbox defaultChecked id={action.id} name={action.id} key={action.key} />}
              />;
      
    }, [action]);

  return (
    <Dialog
      maxWidth='xs'
      open={ open }
      sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 400 } }} 
      PaperProps={{
        component: "form",
        onSubmit: (event) => {
          event.preventDefault();
          const formData = new FormData(event.currentTarget);
          const formJson = Object.fromEntries(formData.entries());
          onOk(formJson);
        }
      }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        <DialogContentText sx={{whiteSpace: 'normal'}}>{text}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
        {action && renderAction(action)}
        <Button type="submit">Готово</Button>
      </DialogActions>
    </Dialog>
  );
};

export default InfoDialog;

